import lottieWeb from "lottie-web";
(function ($) {
    const playIconContainer = document.getElementById("play-icon-song");
    const refreshIconContainer = document.getElementById("refresh-icon-song");
    const audioPlayerContainer = document.getElementById(
        "music-player-song"
    );
    const seekSlider = document.getElementById("seek-slider-song");
    const volumeSlider = document.getElementById("volume-slider-song");
    const muteIconContainer = document.getElementById("mute-icon-song");
    const audio = document.getElementById("track-audio-song");
    const durationContainer = document.getElementById("duration-song");
    const currentTimeContainer = document.getElementById("current-time-song");
    let playState = "play"; 
    let muteState = "unmute";

    const playAnimation = lottieWeb.loadAnimation({
        container: playIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/pause/pause.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Play Animation"
    });

    const muteAnimation = lottieWeb.loadAnimation({
        container: muteIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/mute/mute.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Mute Animation"
    });

    const refreshAnimation = lottieWeb.loadAnimation({
        container: refreshIconContainer,
        path: "https://maxst.icons8.com/vue-static/landings/animated-icons/icons/refresh/refresh.json",
        renderer: "svg",
        loop: false,
        autoplay: false,
        name: "Refresh Animation"
    });

    playAnimation.goToAndStop(14, true);

    // On click play/pause button
    if (playIconContainer != null) {
        playIconContainer.addEventListener("click", () => {
            if (playState === "play") {
                playAnimation.playSegments([14, 27], true);
                playState = "pause";
                audio.play();
            } else {
                playAnimation.playSegments([0, 14], true);
                playState = "play";
                audio.pause();
            }
        });
    }

    if ($('#refresh-icon').length > 0) {
        let refresh = $('#refresh-icon').attr('data-refresh');
        if (refresh == 1) {
            $('#refresh-icon').addClass('refresh');
            // audio.loop = true;
            // audio.load();
            // audio.play()
        }
    }
    
    // On click refresh button
    if (refreshIconContainer != null) {
        refreshIconContainer.addEventListener("click", () => {
            let refresh = $('#refresh-icon').attr('data-refresh');
            if (refresh == 0) {
                $('#refresh-icon').addClass('refresh');
                refresh = 1;
                $('#refresh-icon').attr('data-refresh', refresh)
            } else {
                $('#refresh-icon').removeClass('refresh');
                refresh = 0;
                $('#refresh-icon').attr('data-refresh', refresh)
            }
            $.cookie('refresh', refresh, {
                expires: 1,
                path: '/'
            });
        });
    }

    // On click mute/unmute track button
    if (muteIconContainer != null) {
        muteIconContainer.addEventListener("click", () => {
            if (muteState === "unmute") {
                muteAnimation.playSegments([0, 15], true);
                muteState = "mute";
                audio.volume = 0;
            } else {
                muteAnimation.playSegments([15, 25], true);
                muteState = "unmute";
                audio.volume = 0.99;
            }
        });
    }

    const showRangeProgress = rangeInput => {
        if (rangeInput === seekSlider) {
            audioPlayerContainer.style.setProperty(
                "--seek-before-width",
                (rangeInput.value / rangeInput.max) * 100 + "%"
            );
        } else {
            audioPlayerContainer.style.setProperty(
                "--volume-before-width",
                (rangeInput.value / rangeInput.max) * 100 + "%"
            );
        }
    };

    // On drag the audio track seeker
    if (seekSlider != null) {
        seekSlider.addEventListener("input", e => {
            seekSlider.value = e.target.value;
            audio.currentTime = Number(e.target.value);
            showRangeProgress(e.target);
        });
        seekSlider.addEventListener("mousedown", () => {
            audio.pause();
        });

        seekSlider.addEventListener("mouseup", () => {
            audio.play();
        });
    }



    // On drag the audio volume seeker
    if (volumeSlider != null) {
        volumeSlider.addEventListener("input", e => {
            audio.volume = e.target.value / 100;
            showRangeProgress(e.target);
        });
    }

    // Audio logic

    // Load the audio


    // Play the audio when it's ready
    if (audio != null) {
        audio.load();
        audio.addEventListener("canplay", event => {
            setTimeout(() => {
                audio.play();
                playAnimation.playSegments([14, 27], true);
                playState = "pause";
            }, 400);
        });
        audio.addEventListener("playing", event => {});

    }


    // Change the state of player to playing


    const calculateTime = secs => {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
    };

    const displayDuration = () => {
        durationContainer.textContent = calculateTime(audio.duration);
    };

    const setSliderMax = () => {
        seekSlider.max = Math.floor(audio.duration);
    };

    const displayBufferedAmount = () => {
        const bufferedAmount = Math.floor(
            audio.buffered.end(audio.buffered.length - 1)
        );
        audioPlayerContainer.style.setProperty(
            "--buffered-width",
            `${(bufferedAmount / seekSlider.max) * 100}%`
        );
    };
    if (audio != null) {
        const updateSeeker = () => {
            let refresh = $('#refresh-icon').attr('data-refresh');
            seekSlider.value = audio.currentTime;
            currentTimeContainer.textContent = calculateTime(audio.currentTime);
            if (!isNaN(audio.duration)) {
                durationContainer.textContent = calculateTime(audio.duration);
                if (currentTimeContainer.textContent === durationContainer.textContent && refresh == 1) {
                    audio.loop = true;
                    audio.load();
                    audio.play();
                } else {
                    audio.loop = false; 
                }
            }
            audioPlayerContainer.style.setProperty(
                "--seek-before-width",
                `${(audio.currentTime / audio.duration) * 100}%`
            );
        };

        if (audio.readyState > 0) {
            displayDuration();
            setSliderMax();
            displayBufferedAmount();
        } else {
            audio.addEventListener("loadedmetadata", () => {
                displayDuration();
                setSliderMax();
                displayBufferedAmount();
            });
        }
        audio.addEventListener("progress", displayBufferedAmount);
        audio.addEventListener("timeupdate", updateSeeker);
    }
})(jQuery);
